import React from "react";
import { Box, ButtonGroup, Button, IconButton } from "@mui/material";
import GridOnIcon from "@mui/icons-material/GridOn";
import ViewHeadlineIcon from "@mui/icons-material/ViewHeadline";

export default function TabBar(props) {
  return (
    <Box
      sx={{
        display: "flex",
        marginTop: "10px",
      }}
    >
      {props.showViwModeButtons && (
        <Box
          sx={{
            border: "solid 1px #c8c8c85c",
            backgroundColor: localStorage.getItem("darkMode") === "true" ? "#090909" : "#ededed",
            padding: "2px",
            borderRadius: "2px",

            textWrap: "nowrap",
            position: "fixed",
            zIndex: "999",
          }}
        >
          <>
            <IconButton size="small" onClick={() => props.handleViewMode(1)}>
              <GridOnIcon fontSize="inherit" color={props.viewMode === 1 ? "primary" : ""} />
            </IconButton>
            <IconButton size="small" onClick={() => props.handleViewMode(2)}>
              <ViewHeadlineIcon fontSize="inherit" color={props.viewMode === 2 ? "primary" : ""} />
            </IconButton>
          </>
        </Box>
      )}
      <span
        style={{
          marginLeft: "80px",
        }}
      />

      {props.children}
    </Box>
  );
}
